export enum TipoArchivoImportacion {
   Standard,
   Exportacion,
   Compras,
}
